import { useMerchant } from "../hooks/useMerchant";
import PopupModal from "./PopupModal";
import whatsappUpsell from "../assets/whatsappUpsell.png";

const WhatsappPopUpModal = (): JSX.Element => {
  const { merchant } = useMerchant();
  if (!merchant || merchant.whatsappConfig.active) return <></>;

  return (
    <PopupModal
      img={whatsappUpsell}
      redirectUrl="https://wa.me/573126202787"
      redirectOnBlank
      localStorageKey="whatsappUpsellModal"
      displayOncePer="month"
    />
  );
};
export default WhatsappPopUpModal;
